/**
 * Bambé PDP popup COD checkout.
 * Lead + Purchase: BambeGtmBridge after create_order success, then GTM #create-order-btn click.
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('bambe-popup-checkout-config');
  if (!cfgEl) return;

  var CFG;
  try {
    CFG = JSON.parse(cfgEl.textContent || '{}');
  } catch (e) {
    return;
  }

  var I18N = CFG.i18n || {};
  var PC_VARIANT_ID = Number(CFG.variantId) || 0;
  var PC_PRODUCT_PRICE = Number(CFG.price) || 0;
  var PC_HAS_FREE_DELIVERY = !!CFG.hasFreeDelivery;
  var PC_FEE = Number(CFG.deliveryFee) || Number(window.BAMBE_COD_DELIVERY_FEE) || (window.BAMBE_SHIPPING && window.BAMBE_SHIPPING.fee) || 35;
  var PC_FREE_FROM = Number(CFG.freeFrom) || 400;
  var PC_PRODUCT_TITLE = CFG.productTitle || '';
  var PC_PRODUCT_ID = Number(CFG.productId) || 0;
  var PC_PRODUCT_URL = CFG.productUrl || '';
  var PC_PRODUCT_IMAGE = CFG.productImage || '';
  var SKU_MAP = CFG.variantSkus || {};
  var PC_THANK_YOU = CFG.thankYouUrl || '/pages/thank-you';
  var PRICE_MAP = CFG.variantPrices || {};

  var pcStore = (function () {
    var mem = {};
    return {
      set: function (k, v) {
        try {
          localStorage.setItem(k, v);
        } catch (e) {
          mem[k] = v;
        }
      },
      get: function (k) {
        try {
          return localStorage.getItem(k);
        } catch (e) {
          return mem[k] || null;
        }
      },
    };
  })();

  function moneyLabel(n) {
    return Math.round(n) + ' ' + (I18N.currency || 'درهم');
  }

  function pcCalcShipping(price, freeTag) {
    return price >= PC_FREE_FROM || freeTag ? 0 : PC_FEE;
  }

  function getQty() {
    var root = document.querySelector('.product--parent') || document;
    var qtyInput = root.querySelector('.quantity__input[name="quantity"]');
    if (qtyInput) {
      var q = parseInt(qtyInput.value, 10);
      if (!isNaN(q) && q > 0) return q;
    }
    return 1;
  }

  function pcSetQty(n) {
    var root = document.querySelector('.product--parent') || document;
    var qtyInput = root.querySelector('.quantity__input[name="quantity"]');
    if (!qtyInput) return;
    qtyInput.value = String(n);
    try {
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {}
  }

  /**
   * Same inventory rule as "Add to cart": FormData POST /cart/add.js
   * (JSON body can oversell; the product form uses FormData and Shopify enforces stock there.)
   * On failure → show the same error and return null (undo any partial add).
   * On success → undo the probe line and return allowed qty.
   */
  function pcRemoveVariantFromCart(variantId) {
    return fetch(getCartJsUrl(), { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var target = String(variantId);
        var ops = [];
        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          if (String(it.variant_id) === target || String(it.id) === target) {
            ops.push(
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: it.key, quantity: 0 }),
                credentials: 'same-origin',
              }).catch(function () {})
            );
          }
        }
        return Promise.all(ops);
      })
      .catch(function () {});
  }

  function pcStockLimitMessage(availableQty) {
    var isFr =
      (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('fr') === 0;
    var n = availableQty != null && availableQty !== '' ? String(availableQty) : '0';
    if (isFr) {
      return 'Impossible d’augmenter la quantité — seulement ' + n + ' disponible(s).';
    }
    return 'لا يمكن زيادة الكمية — المتوفر هو ' + n + ' فقط.';
  }

  function pcExtractAvailableQty(errMsg, cart, variantId) {
    var msg = String(errMsg || '');
    var m =
      msg.match(/only\s+(\d+)\s+items?\s+(?:was|were)\s+added/i) ||
      msg.match(/you can only add\s+(\d+)/i) ||
      msg.match(/all\s+(\d+)\s+/i) ||
      msg.match(/المتوفر هو\s*(\d+)/) ||
      msg.match(/seulement\s+(\d+)/i);
    if (m) return parseInt(m[1], 10);

    var target = String(variantId);
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (String(it.variant_id) === target || String(it.id) === target) {
        return parseInt(it.quantity, 10) || 0;
      }
    }

    var mapEl = document.getElementById('bambe-variant-qty-max');
    if (mapEl) {
      try {
        var map = JSON.parse(mapEl.textContent || '{}');
        if (map[target] != null) {
          var n = parseInt(map[target], 10);
          if (!isNaN(n)) return n;
        }
      } catch (e) {}
    }
    return null;
  }

  function pcEnforceInventoryQty(variantId, qty) {
    var fd = new FormData();
    fd.set('id', String(variantId));
    fd.set('quantity', String(qty));

    return fetch(getCartAddUrl(), {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: fd,
      credentials: 'same-origin',
    })
      .then(function (r) {
        return r.text().then(function (text) {
          var data = {};
          try {
            data = text ? JSON.parse(text) : {};
          } catch (e) {
            data = {};
          }
          return { ok: r.ok, data: data };
        });
      })
      .then(function (res) {
        var data = res.data || {};
        var allowed = parseInt(data.quantity, 10);
        var errMsg = data.description || data.message || '';

        /* Same as product-form: status / !ok → block popup and show stock message */
        if (!res.ok || data.status) {
          return fetch(getCartJsUrl(), { credentials: 'same-origin' })
            .then(function (r) {
              return r.json();
            })
            .catch(function () {
              return { items: [] };
            })
            .then(function (cart) {
              var avail = pcExtractAvailableQty(errMsg, cart, variantId);
              if (avail == null && !isNaN(allowed) && allowed > 0) avail = allowed;
              showAddError(pcStockLimitMessage(avail != null ? avail : 0));
              return pcRemoveVariantFromCart(variantId).then(function () {
                return null;
              });
            });
        }

        if (isNaN(allowed) || allowed < 1) allowed = qty;
        return pcRemoveVariantFromCart(variantId).then(function () {
          return allowed;
        });
      })
      .catch(function () {
        return fetch(getCartJsUrl(), { credentials: 'same-origin' })
          .then(function (r) {
            return r.json();
          })
          .catch(function () {
            return { items: [] };
          })
          .then(function (cart) {
            var avail = pcExtractAvailableQty('', cart, variantId);
            showAddError(pcStockLimitMessage(avail != null ? avail : 0));
            return pcRemoveVariantFromCart(variantId).then(function () {
              return null;
            });
          });
      });
  }

  function pcSyncCurrentVariant() {
    var root = document.querySelector('.product--parent') || document;
    var hiddenInput = root.querySelector('form[data-type="add-to-cart-form"] input[name="id"], product-form input[name="id"], input[name="id"]');
    if (!hiddenInput) return;
    var parsedId = parseInt(hiddenInput.value, 10);
    if (!isNaN(parsedId) && parsedId > 0) {
      PC_VARIANT_ID = parsedId;
      if (PRICE_MAP[String(parsedId)] != null) {
        PC_PRODUCT_PRICE = Number(PRICE_MAP[String(parsedId)]) || PC_PRODUCT_PRICE;
      }
    }
  }

  function variantMetaLine(qty) {
    var opt = (CFG.variantOptions && CFG.variantOptions[String(PC_VARIANT_ID)]) || getSelectedSize() || '';
    if (
      !opt ||
      opt === 'Default Title' ||
      opt === 'العنوان الافتراضي' ||
      opt === 'Titre par défaut'
    ) {
      opt = '';
    }
    var qtyPart = (I18N.qtyLabel || (CFG.isFr ? 'Quantité' : 'الكمية')) + ' ' + qty;
    return opt ? opt + ' · ' + qtyPart : qtyPart;
  }

  function pcUpdateRecap(qty) {
    var titleEl = document.getElementById('pcRecapTitle');
    var metaEl = document.getElementById('pcRecapMeta');
    var priceEl = document.getElementById('pcRecapPrice');
    var imgEl = document.getElementById('pcRecapImg');
    if (titleEl) titleEl.textContent = PC_PRODUCT_TITLE;
    if (metaEl) metaEl.textContent = variantMetaLine(qty);
    if (priceEl) priceEl.textContent = moneyLabel(PC_PRODUCT_PRICE);
    if (imgEl) {
      var imgs = CFG.variantImages || {};
      var src = imgs[String(PC_VARIANT_ID)] || PC_PRODUCT_IMAGE || '';
      if (src) {
        imgEl.src = src;
        imgEl.removeAttribute('hidden');
        imgEl.alt = PC_PRODUCT_TITLE;
      } else {
        imgEl.setAttribute('hidden', '');
      }
    }
  }

  function pcUpdatePrices() {
    pcSyncCurrentVariant();
    var qty = getQty();
    var price = PC_PRODUCT_PRICE * qty;
    var shipping = pcCalcShipping(price, PC_HAS_FREE_DELIVERY);
    var total = Math.round(price + shipping);

    var subEl = document.getElementById('pcSubtotal');
    var shipEl = document.getElementById('pcShipping');
    var totEl = document.getElementById('pcTotal');
    if (subEl) subEl.textContent = moneyLabel(price);
    if (shipEl) {
      if (shipping === 0) {
        shipEl.textContent = I18N.free || 'مجاني';
        shipEl.classList.add('free');
      } else {
        shipEl.textContent = moneyLabel(shipping);
        shipEl.classList.remove('free');
      }
    }
    if (totEl) totEl.textContent = moneyLabel(total);

    pcUpdateRecap(qty);

    var banner = document.getElementById('pcFreeBanner');
    var bannerText = document.getElementById('pcFreeBannerText');
    if (banner && bannerText) {
      if (PC_HAS_FREE_DELIVERY || price >= PC_FREE_FROM) {
        banner.style.setProperty('--pc-length', String(PC_FREE_FROM));
        banner.style.setProperty('--pc-max', String(PC_FREE_FROM));
        banner.classList.add('show', 'reached');
        bannerText.textContent = I18N.freeReached || '';
      } else {
        var remaining = Math.round(PC_FREE_FROM - price);
        banner.style.setProperty('--pc-length', String(Math.round(price)));
        banner.style.setProperty('--pc-max', String(PC_FREE_FROM));
        banner.classList.add('show');
        banner.classList.remove('reached');
        bannerText.textContent = (I18N.freeRemaining || '').replace('[amount]', String(remaining));
      }
    }

    return {
      price: Math.round(price),
      shipping: shipping,
      total: total,
      qty: qty,
      unitPrice: Math.round(PC_PRODUCT_PRICE),
      billingQty: qty,
    };
  }

  function getSelectedSize() {
    var root = document.querySelector('.product--parent') || document;
    var checked = root.querySelector(
      'input[type="radio"][name^="options"]:checked, fieldset input:checked'
    );
    if (checked) {
      var label = checked.getAttribute('value') || '';
      if (label) return label;
    }
    var opt = CFG.variantOptions && CFG.variantOptions[String(PC_VARIANT_ID)];
    return opt || '';
  }

  function fireLeadForGtm(ecommerce, customer) {
    /* Prefer full payload for Meta/GA4 (cEvent - lead). Also fake #create-order-btn for UserData Push. */
    try {
      window.dataLayer = window.dataLayer || [];
      if (ecommerce && Number(ecommerce.value) > 0) {
        var userData =
          window.BambeGtmBridge && typeof BambeGtmBridge.buildUserData === 'function'
            ? BambeGtmBridge.buildUserData(customer)
            : {
                name: (customer && customer.name) || '',
                phone: (customer && customer.phone) || '',
                city: (customer && customer.city) || '',
                address: (customer && customer.address) || '',
                email: '',
                country: 'ma',
              };
        window.dataLayer.push({
          event: 'lead',
          ecommerce: {
            currency: ecommerce.currency || 'MAD',
            value: Number(ecommerce.value) || 0,
            items: ecommerce.items || [],
          },
          user_data: userData,
        });
      }
    } catch (e) {}

    var fakeBtn = document.createElement('button');
    fakeBtn.id = 'create-order-btn';
    fakeBtn.type = 'button';
    fakeBtn.style.display = 'none';
    document.body.appendChild(fakeBtn);
    fakeBtn.click();
    fakeBtn.remove();
  }

  function onOrderSuccess(resp, nums, customer) {
    var orderId =
      window.BambeGtmBridge && typeof BambeGtmBridge.extractOrderId === 'function'
        ? BambeGtmBridge.extractOrderId(resp)
        : resp.order_id || resp.orderId || resp.id || null;

    pcStore.set('ce_price', String(nums.price));
    pcStore.set('ce_shipping_fees', String(nums.shipping));
    pcStore.set('ce_had_free_delivery_tag', String(PC_HAS_FREE_DELIVERY));
    pcStore.set('ce_applied_coupon', 'null');
    pcStore.set(
      'ce_order_items',
      JSON.stringify([
        {
          title: PC_PRODUCT_TITLE,
          size: getSelectedSize(),
          url: PC_PRODUCT_URL,
          image: PC_PRODUCT_IMAGE,
          unit_price: nums.unitPrice,
          quantity: nums.qty,
          line_total: nums.price,
        },
      ])
    );

    if (window.BambeGtmBridge && typeof BambeGtmBridge.fromPopupSuccess === 'function') {
      BambeGtmBridge.fromPopupSuccess(
        nums,
        PC_VARIANT_ID,
        PC_PRODUCT_TITLE,
        customer,
        orderId
      );
    }

    try {
      if (window.BambeTikTok && typeof BambeTikTok.leadFromOrder === 'function') {
        BambeTikTok.leadFromOrder({
          items: [
            {
              variant_id: PC_VARIANT_ID,
              product_title: PC_PRODUCT_TITLE,
              price: nums.unitPrice * 100,
              final_price: nums.unitPrice * 100,
              quantity: nums.qty,
            },
          ],
          value: nums.total,
          orderId: orderId,
          customer: customer,
        });
      }
    } catch (ttErr) {
      console.warn('Bambé TikTok Lead error', ttErr);
    }

    var ecommerce = null;
    try {
      ecommerce = JSON.parse(pcStore.get('checkout_data') || 'null');
    } catch (e) {}
    fireLeadForGtm(ecommerce, customer);

    window.location.href = PC_THANK_YOU;
  }

  function getCartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function getCartJsUrl() {
    if (window.routes && window.routes.cart_url) {
      return String(window.routes.cart_url).replace(/\/$/, '') + '.js';
    }
    return '/cart.js';
  }

  function getCartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add.js';
  }

  function pcErrorFallback() {
    var isFr =
      (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('fr') === 0;
    return isFr
      ? 'Impossible d’ajouter le produit au panier.'
      : 'تعذر إضافة المنتج إلى السلة';
  }

  function showAddError(message) {
    var raw = message;
    if (raw == null || raw === '' || String(raw) === 'undefined') {
      raw = pcErrorFallback();
    }
    /* Pass raw Shopify/theme message once — showNotifications translates it */
    if (typeof window.showNotifications === 'function') {
      window.showNotifications(raw);
      return;
    }
    var text =
      typeof window.bambeTranslateCartError === 'function'
        ? window.bambeTranslateCartError(String(raw))
        : String(raw);
    if (!text || text === 'undefined') text = pcErrorFallback();
    console.warn(text);
  }

  function pcTryAddVariantToCart(variantId, qty) {
    var fd = new FormData();
    fd.set('id', String(variantId));
    fd.set('quantity', String(qty));
    return fetch(getCartAddUrl(), {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: fd,
      credentials: 'same-origin',
    })
      .then(function (r) {
        return r.text().then(function (text) {
          var data = {};
          try {
            data = text ? JSON.parse(text) : {};
          } catch (e) {
            data = {};
          }
          return { ok: r.ok, data: data };
        });
      })
      .then(function (res) {
        if (!res.ok || (res.data && res.data.status)) {
          var errMsg = (res.data && (res.data.description || res.data.message)) || '';
          return fetch(getCartJsUrl(), { credentials: 'same-origin' })
            .then(function (r) {
              return r.json();
            })
            .catch(function () {
              return { items: [] };
            })
            .then(function (cart) {
              var avail = pcExtractAvailableQty(errMsg, cart, variantId);
              var allowed = parseInt(res.data && res.data.quantity, 10);
              if (avail == null && !isNaN(allowed) && allowed > 0) avail = allowed;
              showAddError(pcStockLimitMessage(avail != null ? avail : 0));
              return false;
            });
        }
        return true;
      })
      .catch(function () {
        showAddError(pcStockLimitMessage(0));
        return false;
      });
  }

  window.pcAddMoreItems = function () {
    var btn = document.getElementById('pcAddMore');
    if (!btn) return;
    btn.disabled = true;
    var prev = btn.innerHTML;
    btn.innerHTML =
      '<span class="pc-spin" style="display:inline-block;width:18px;height:18px;vertical-align:middle;margin-inline-start:8px"></span> ' +
      (I18N.loading || '');

    pcSyncCurrentVariant();
    var qty = getQty();

    pcTryAddVariantToCart(PC_VARIANT_ID, qty)
      .then(function (success) {
        if (success) {
          pcClosePopup();
          window.location.reload();
          return;
        }
        btn.disabled = false;
        btn.innerHTML = prev;
      });
  };

  window.pcOpenPopup = function () {
    var overlay = document.getElementById('pcOverlay');
    if (!overlay || overlay.classList.contains('active')) return;
    /* Hoist to <body> so sticky header stacking context cannot sit above the dimmer */
    if (overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }
    pcSyncCurrentVariant();
    pcUpdatePrices();
    overlay.classList.add('active');
    document.body.classList.add('pc-popup-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      var nameEl = document.getElementById('pc-name');
      if (nameEl) nameEl.focus();
    }, 400);
  };

  function pcGetInventoryMax(variantId) {
    var key = String(variantId);
    var mapEl = document.getElementById('bambe-variant-qty-max');
    if (mapEl) {
      try {
        var map = JSON.parse(mapEl.textContent || '{}');
        if (Object.prototype.hasOwnProperty.call(map, key) && map[key] != null) {
          var n = parseInt(map[key], 10);
          if (!isNaN(n)) return n;
        }
      } catch (e) {}
    }
    var root = document.querySelector('.product--parent') || document;
    var qtyInput = root.querySelector('.quantity__input[name="quantity"]');
    if (qtyInput) {
      var raw = qtyInput.getAttribute('max') || qtyInput.getAttribute('data-max');
      if (raw && raw !== 'null') {
        var m = parseInt(raw, 10);
        if (!isNaN(m)) return m;
      }
    }
    return null;
  }

  /** Instant stock check (Liquid inventory map) — no cart/add round-trip */
  function pcAssertQtyAllowed(variantId, qty) {
    var max = pcGetInventoryMax(variantId);
    if (max == null) return true;
    if (qty <= max) return true;
    showAddError(pcStockLimitMessage(max));
    return false;
  }

  /* Cart already has items → add + /cart. Empty cart → instant inventory map check, then popup. */
  window.pcOpenPopupFromButton = function (btn) {
    if (btn && btn.dataset.locked === '1') return;
    if (btn) {
      btn.dataset.locked = '1';
      btn.disabled = true;
    }

    function unlock() {
      if (!btn) return;
      btn.disabled = false;
      btn.dataset.locked = '0';
    }

    pcSyncCurrentVariant();
    var qty = getQty();

    /* Fast path: block oversell instantly from theme inventory map (Shopify community pattern) */
    if (!pcAssertQtyAllowed(PC_VARIANT_ID, qty)) {
      unlock();
      return;
    }

    fetch(getCartJsUrl(), { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (cart && cart.item_count > 0) {
          return pcTryAddVariantToCart(PC_VARIANT_ID, qty).then(function (success) {
            if (success) window.location.href = getCartUrl();
            else unlock();
          });
        }
        pcOpenPopup();
        unlock();
      })
      .catch(function () {
        /* If cart.js fails, still open when local stock check passed */
        pcOpenPopup();
        unlock();
      });
  };

  window.pcClosePopup = function () {
    var overlay = document.getElementById('pcOverlay');
    if (overlay) {
      overlay.classList.remove('active', 'pc-kb-open');
      overlay.style.removeProperty('--pc-vvh');
      var popup = overlay.querySelector('.pc-popup');
      if (popup) popup.style.maxHeight = '';
    }
    document.body.classList.remove('pc-popup-open');
    document.body.style.overflow = '';
    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }
  };

  function pcLogExtra() {
    var qty = getQty();
    var unit = Math.round(PC_PRODUCT_PRICE);
    var price = Math.round(unit * qty);
    var shipping = 0;
    var total = 0;
    try {
      var shipEl = document.getElementById('pcShipping');
      var shipText = (shipEl && shipEl.textContent) || '';
      shipping = /مجاني|gratuit/i.test(shipText) ? 0 : parseFloat(String(shipText).replace(/[^\d.]/g, '')) || 0;
      total = parseFloat(String((document.getElementById('pcTotal') || {}).textContent || '').replace(/[^\d.]/g, '')) || price + shipping;
    } catch (e) {
      shipping = 0;
      total = price;
    }
    return {
      items: [
        {
          title: PC_PRODUCT_TITLE,
          variant: getSelectedSize() || '',
          qty: qty || 1,
          price: unit,
          sku: SKU_MAP[String(PC_VARIANT_ID)] || CFG.sku || '',
          variant_id: PC_VARIANT_ID,
          product_id: PC_PRODUCT_ID
        }
      ],
      subtotal: price,
      shipping: shipping,
      total: total
    };
  }

  function pcCheckoutLog(kind, reason) {
    try {
      var log = window.BambeCheckoutLog;
      if (!log) return;
      var extra = pcLogExtra();
      if (kind === 'fail') log.fail('popup', reason || 'connection_error', extra);
      else if (kind === 'converted') log.converted('popup', extra);
    } catch (e) {}
  }

  function pcValidate() {
    var valid = true;
    var fields = [
      { id: 'pcF-name', input: 'pc-name', check: function (v) { return v.length >= 2; } },
      {
        id: 'pcF-phone',
        input: 'pc-phone',
        check: function (v) {
          if (window.BambeGtmBridge && typeof BambeGtmBridge.normalizeMaPhone === 'function') {
            return !!BambeGtmBridge.normalizeMaPhone(v);
          }
          return /^0[567]\d{8}$/.test(String(v || '').replace(/\D/g, ''));
        },
      },
      { id: 'pcF-city', input: 'pc-city', check: function (v) { return v.length >= 2; } },
      { id: 'pcF-address', input: 'pc-address', check: function (v) { return v.length >= 5; } },
    ];
    fields.forEach(function (f) {
      var el = document.getElementById(f.id);
      var input = document.getElementById(f.input);
      if (!el || !input) return;
      var val = input.value.trim();
      if (!f.check(val)) {
        el.classList.add('error');
        valid = false;
      } else {
        el.classList.remove('error');
      }
    });
    if (!valid) {
      try {
        if (window.BambeCheckoutLog && typeof BambeCheckoutLog.skipAbandon === 'function') {
          BambeCheckoutLog.skipAbandon();
        }
      } catch (eSkip) {}
      return false;
    }
    return true;
  }

  function pcReferrerHost(ref) {
    try {
      if (!ref) return '';
      return new URL(ref).hostname || '';
    } catch (e) {
      return '';
    }
  }

  function pcLandingPath(landing) {
    try {
      if (!landing) return '';
      var s = String(landing);
      var q = s.indexOf('?');
      if (q >= 0) s = s.slice(0, q);
      var h = s.indexOf('#');
      if (h >= 0) s = s.slice(0, h);
      return s;
    } catch (e) {
      return '';
    }
  }

  /* Same first-touch attribution as cart checkout (ce_first_touch_v1 in theme.liquid) */
  function pcGetUserReferringSite() {
    try {
      if (typeof window.ceGetUserReferringSite === 'function') {
        return window.ceGetUserReferringSite();
      }
      var KEY = 'ce_first_touch_v1';
      var stored = {};
      try {
        if (window.localStorage && localStorage.getItem(KEY)) {
          stored = JSON.parse(localStorage.getItem(KEY) || '{}') || {};
        }
      } catch (e) {
        stored = {};
      }
      var params = new URLSearchParams(window.location.search || '');
      var utmSource = stored.utm_source || params.get('utm_source') || '';
      var utmContent = stored.utm_content || params.get('utm_content') || '';
      var adId = stored.ad_id || params.get('ad_id') || '';
      var gclid = stored.gclid || params.get('gclid') || '';
      var fbclid = stored.fbclid || params.get('fbclid') || '';
      var ttclid = stored.ttclid || params.get('ttclid') || '';
      var yclid = stored.yclid || params.get('yclid') || '';
      var msclkid = stored.msclkid || params.get('msclkid') || '';
      var referrer = stored.referrer || '';
      try {
        if (!referrer) referrer = document.referrer || '';
      } catch (e) {}
      var refHost = pcReferrerHost(referrer);
      var ownHost = (stored.host || window.location.hostname || '').toLowerCase();
      if (refHost && ownHost && refHost.toLowerCase() === ownHost) refHost = '';

      var source = '';
      if (utmSource) source = String(utmSource).toLowerCase();
      else if (ttclid) source = 'tiktok';
      else if (fbclid) source = 'facebook';
      else if (gclid) source = 'google';
      else if (yclid) source = 'youtube';
      else if (msclkid) source = 'bing';
      else if (refHost) source = refHost;
      else source = 'direct';

      var lines = [source];
      if (ttclid) lines.push('ttclid');
      if (fbclid) lines.push('fbclid');
      if (gclid) lines.push('gclid');
      if (yclid) lines.push('yclid');
      if (msclkid) lines.push('msclkid');
      if (adId) {
        lines.push('Ad : ' + adId);
        if (utmContent && String(utmContent) !== String(adId)) {
          lines.push('Content : ' + utmContent);
        }
      } else if (utmContent) {
        lines.push('Ad : ' + utmContent);
      }

      var siteHost = stored.host || window.location.hostname || '';
      try {
        var pathNow = window.location.pathname || '';
        var langNow = (document.documentElement.lang || '').toLowerCase();
        var shopifyLocale =
          window.Shopify && Shopify.locale ? String(Shopify.locale).toLowerCase() : '';
        var isFrStore =
          pathNow.indexOf('/fr') === 0 ||
          langNow.indexOf('fr') === 0 ||
          shopifyLocale.indexOf('fr') === 0;
        if (isFrStore && siteHost) {
          siteHost = String(siteHost).replace(/\/fr\/?$/i, '') + '/fr';
        }
      } catch (eFr) {}
      var landPath = pcLandingPath(stored.landing);
      if (landPath) lines.push('land:' + landPath.slice(0, 80));
      lines.push('site:' + siteHost);

      return lines.join('\n').slice(0, 500);
    } catch (e) {
      try {
        return 'direct\nsite:' + (window.location.hostname || '');
      } catch (e2) {
        return 'direct';
      }
    }
  }

  window.pcSubmitOrder = function () {
    if (!pcValidate()) return;

    var btn = document.getElementById('pcSubmit');
    var alertEl = document.getElementById('pcAlert');
    if (btn) btn.classList.add('loading');
    if (alertEl) alertEl.classList.remove('show');

    pcSyncCurrentVariant();
    var requestedQty = getQty();

    if (!pcAssertQtyAllowed(PC_VARIANT_ID, requestedQty)) {
      if (btn) btn.classList.remove('loading');
      return;
    }

    var nums = pcUpdatePrices();
    var name = (document.getElementById('pc-name') || {}).value.trim();
    var phone = (document.getElementById('pc-phone') || {}).value.trim();
    var city = (document.getElementById('pc-city') || {}).value.trim();
    var address = (document.getElementById('pc-address') || {}).value.trim();
    var customer = { name: name, phone: phone, city: city, address: address };
    var userReferringSite = pcGetUserReferringSite();

    var data = {
      draft_order: {
        source_name: 'web',
        inventory_behaviour: 'decrement_obeying_policy',
        line_items: [{ variant_id: PC_VARIANT_ID, quantity: requestedQty }],
        email: phone + '@bambe.ma',
        phone: phone,
        customer: {
          first_name: name,
          last_name: null,
          email: phone + '@bambe.ma',
          phone: phone,
        },
        billing_address: {
          first_name: name,
          last_name: null,
          address1: address,
          phone: phone,
          city: city,
          province: city,
          country: 'Morocco',
          zip: '',
        },
        shipping_address: {
          first_name: name,
          last_name: null,
          address1: address,
          phone: phone,
          city: city,
          province: city,
          country: 'Morocco',
          zip: '',
        },
        financial_status: 'pending',
        shipping_line: { title: 'Livraison', price: nums.shipping },
        note: 'Popup Checkout | Payment Method: cod',
        payment_method: 'cod',
        /* Same attribution field as cart checkout */
        user_referring_site: userReferringSite,
        /* Channel in Additional details only — no order tag (avoids tag clutter) */
        Channel: 'Popup Checkout',
        note_attributes: [
          { name: 'Channel', value: 'Popup Checkout' },
          { name: 'User referring site', value: userReferringSite },
        ],
        blacklist_notify_customer: !!CFG.blacklistShowMessage,
        blacklist_message: I18N.blacklistMessage || '',
      },
    };

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/apps/bambe/create_order.php', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.timeout = 25000;

    function showErr(msg) {
      if (btn) btn.classList.remove('loading');
      if (alertEl) {
        alertEl.innerHTML =
          msg ||
          (I18N.errorHtml || '') ||
          'Error.<br><a href="https://api.whatsapp.com/send?phone=212771494218&text=Erreur%20commande" target="_blank" class="ce-conn-error-wa">WhatsApp</a>';
        alertEl.classList.add('show');
      }
    }

    xhr.onload = function () {
      if (btn) btn.classList.remove('loading');
      try {
        var resp = JSON.parse(xhr.responseText);
        if (resp.status === 'success') {
          pcCheckoutLog('converted');
          onOrderSuccess(resp, nums, customer);
        } else if (resp.code === 'blacklisted') {
          showErr(I18N.blacklistMessageHtml || resp.message || I18N.blacklistMessage || I18N.errorHtml);
        } else {
          showErr();
          pcCheckoutLog('fail', 'connection_error');
        }
      } catch (e) {
        showErr();
        pcCheckoutLog('fail', 'connection_error');
      }
    };
    xhr.onerror = function () {
      showErr();
      pcCheckoutLog('fail', 'connection_error');
    };
    xhr.ontimeout = function () {
      showErr();
      pcCheckoutLog('fail', 'connection_error');
    };
    xhr.send(JSON.stringify(data));
  };

  function bindOrderButtons() {
    document.querySelectorAll('[data-bambe-popup-checkout]').forEach(function (btn) {
      if (btn.dataset.pcBound === '1') return;
      btn.dataset.pcBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.disabled || btn.classList.contains('disabled')) return;
        var terms = btn.closest('.tp-buy-button');
        var checkbox = terms && terms.querySelector('.agree_terms_conditions');
        if (checkbox && !checkbox.checked) {
          alert(I18N.termsError || '');
          return;
        }
        pcOpenPopupFromButton(btn);
      });
    });
  }

  var root = document.querySelector('.product--parent');
  if (root) {
    var priceTimer = null;
    var observer = new MutationObserver(function (mutations) {
      var relevant = false;
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (!t || !t.closest) continue;
        // Ignore popup DOM updates (prevents infinite loop with pcUpdatePrices)
        if (t.closest('#pcOverlay')) continue;
        if (
          (t.matches && t.matches('input[name="id"], .quantity__input, .price-item--sale, .price-item--regular')) ||
          (t.closest && t.closest('.price, .product-form, quantity-input, variant-selects, variant-radios'))
        ) {
          relevant = true;
          break;
        }
      }
      if (!relevant) return;
      pcSyncCurrentVariant();
      if (priceTimer) clearTimeout(priceTimer);
      priceTimer = setTimeout(function () {
        var ov = document.getElementById('pcOverlay');
        if (ov && ov.classList.contains('active')) pcUpdatePrices();
      }, 80);
    });
    observer.observe(root, { subtree: true, childList: true, attributes: true, characterData: true });
  }

  if (window.PUB_SUB_EVENTS && typeof subscribe === 'function') {
    subscribe(window.PUB_SUB_EVENTS.variantChange, function () {
      pcSyncCurrentVariant();
      pcUpdatePrices();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') pcClosePopup();
  });

  /** Arabic script → RTL; Latin / digits / phone → LTR */
  function pcHasArabic(str) {
    return /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/.test(str || '');
  }

  function pcSyncFieldDir(el) {
    if (!el) return;
    var v = (el.value || '').trim();
    var overlay = document.getElementById('pcOverlay');
    var isLtr = overlay && overlay.getAttribute('data-pc-dir') === 'ltr';

    if (el.id === 'pc-phone') {
      /* Empty: RTL so Arabic placeholder sits right; typed digits: LTR left */
      el.setAttribute('dir', v ? 'ltr' : (isLtr ? 'ltr' : 'rtl'));
      return;
    }
    if (!v) {
      el.setAttribute('dir', isLtr ? 'ltr' : 'rtl');
      return;
    }
    el.setAttribute('dir', pcHasArabic(v) ? 'rtl' : 'ltr');
  }

  ['pc-name', 'pc-phone', 'pc-city', 'pc-address'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) {
      pcSyncFieldDir(el);
      el.addEventListener('input', function () {
        var field = this.closest('.pc-field');
        if (field) field.classList.remove('error');
        pcSyncFieldDir(this);
      });
      el.addEventListener('blur', function () {
        pcSyncFieldDir(this);
      });
    }
  });

  var overlay = document.getElementById('pcOverlay');
  if (overlay) {
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) pcClosePopup();
    });
    overlay.addEventListener('focusin', function (e) {
      var t = e.target;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA')) {
        pcFitPopupToKeyboard();
      }
    });
    overlay.addEventListener('focusout', function () {
      setTimeout(pcFitPopupToKeyboard, 80);
    });
  }

  function pcIsMobilePopup() {
    return window.matchMedia('(max-width: 480px)').matches;
  }

  function pcIsNewPopupStyle() {
    var overlayEl = document.getElementById('pcOverlay');
    var style = overlayEl && overlayEl.getAttribute('data-pc-style');
    return style === 'product_recap' || style === 'stacked_summary';
  }

  function pcFitPopupToKeyboard() {
    var overlayEl = document.getElementById('pcOverlay');
    if (!overlayEl || !overlayEl.classList.contains('active')) return;
    var popup = overlayEl.querySelector('.pc-popup');
    var active = document.activeElement;
    var typing =
      active &&
      overlayEl.contains(active) &&
      (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA');
    var vv = window.visualViewport;
    var visibleH = vv ? vv.height : window.innerHeight;
    if (pcIsNewPopupStyle() && pcIsMobilePopup() && typing) {
      overlayEl.classList.add('pc-kb-open');
      overlayEl.style.setProperty('--pc-vvh', Math.round(visibleH) + 'px');
      if (popup) popup.style.maxHeight = Math.max(280, Math.round(visibleH) - 16) + 'px';
      setTimeout(function () {
        if (!active || !popup) return;
        var ar = active.getBoundingClientRect();
        var pr = popup.getBoundingClientRect();
        if (ar.bottom > pr.bottom - 12) {
          popup.scrollTop += ar.bottom - pr.bottom + 20;
        } else if (ar.top < pr.top + 12) {
          popup.scrollTop -= pr.top - ar.top + 20;
        }
      }, 60);
    } else {
      overlayEl.classList.remove('pc-kb-open');
      overlayEl.style.removeProperty('--pc-vvh');
      if (popup) popup.style.maxHeight = '';
    }
  }

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', pcFitPopupToKeyboard);
    window.visualViewport.addEventListener('scroll', pcFitPopupToKeyboard);
  }
  window.addEventListener('resize', pcFitPopupToKeyboard);

  var submitBtn = document.getElementById('pcSubmit');
  if (submitBtn) submitBtn.addEventListener('click', function (e) {
    e.preventDefault();
    pcSubmitOrder();
  });

  var moreBtn = document.getElementById('pcAddMore');
  if (moreBtn) moreBtn.addEventListener('click', function (e) {
    e.preventDefault();
    pcAddMoreItems();
  });

  var closeBtn = document.querySelector('.pc-close');
  if (closeBtn) closeBtn.addEventListener('click', function (e) {
    e.preventDefault();
    pcClosePopup();
  });

  bindOrderButtons();
  pcUpdatePrices();
  document.addEventListener('shopify:section:load', bindOrderButtons);
})();
